import { IBrickInstanceTargetingAction } from 'src/app/store/utility/IBrickInstanceTargetingAction';
import { SamwinCallInfoRemoteDto } from 'src/generated/signalR/samwin-call-info-remote-dto';

export class SelectCall implements IBrickInstanceTargetingAction {
   public static readonly type = '[CallWaitListBehaviour] Select call';
   constructor(public brickInstanceId: string, public call: SamwinCallInfoRemoteDto, public position?: number) {}
}

export class ClearSelectedCall implements IBrickInstanceTargetingAction {
   public static readonly type = '[CallWaitListBehaviour] Clear selected call';
   constructor(public brickInstanceId: string) {}
}
